export default {
    'loginForm.title': ' Enter',
    'loginForm.fields.email.label': 'Email',
    'loginForm.fields.password.label': 'Password',
    'loginForm.buttons.login.title': 'Enter',
    'loginForm.errors.unableLogin': ' Login error. Please try again later.',
    'loginForm.fields.forgotPassword.label': 'Have you forgotten your password?',

    'accountRecoveryInitiate.title': 'Have you forgotten your password?',
    'accountRecoveryInitiate.buttons.restore.title': 'Restore',
    'accountRecoveryInitiate.buttons.back.title': 'Back',
    'accountRecoveryInitiate.fields.email.label': 'Email',
    'accountRecoveryInitiate.errors.unableRecovery': ' Account recovery error. Please try again later.',
    'accountRecoveryInitiate.events.emailSentSuccess': 'Account recovery email sent successfully',
    'accountRecoveryInitiate.hint.nextAttemptAfter': 'Next try is possible in',
    'accountRecoveryInitiate.description': 'Send a log in link to your email',

    'accountRecoveryFinish.title': 'Password setting',
    'accountRecoveryFinish.errors.unableRecovery': 'Account recovery error. Please try again later.',
    'accountRecoveryFinish.hint.enterPasswordForAccount': 'Enter a new password for your account',
    'accountRecoveryFinish.buttons.tryAgain.title': 'Repeat',
    'accountRecoveryFinish.fields.password.label': 'Password',
    'accountRecoveryFinish.fields.password.hint': 'It must contain at least one digit and be at least 8 characters long',
    'accountRecoveryFinish.fields.confirmPassword.label': 'Password confirmation',
    'accountRecoveryFinish.buttons.restore.title': 'Restore',
    'accountRecoveryFinish.validation.passwordMaxLength': ' A password must not exceed 72 characters',
    'accountRecoveryFinish.validation.passwordMinLength': 'A password must not be shorter than 8 characters',
    'accountRecoveryFinish.validation.noPassword': 'Enter a password',
    'accountRecoveryFinish.validation.noConfirmPassword': 'Enter a password confirmation',
    'accountRecoveryFinish.validation.passwordsMismatch': "Passwords don't match",
    'accountRecoveryFinish.notification.accountRecovered': 'Account access has been successfully restored! Use the new password to log in to your personal account',

    'invite.title': 'Account creation completion',
    'invite.fields.password.label': 'Password',
    'invite.fields.password.hint': 'It must contain at least one digit and be at least 8 characters long',
    'invite.fields.confirmPassword.label': 'Password confirmation',
    'invite.errors.unableRecovery': 'Account registration completion error. Please try again later.',
    'invite.validation.passwordMaxLength': ' A password must not exceed 72 characters',
    'invite.validation.passwordMinLength': 'A password must not be shorter than 8 characters',
    'invite.validation.noPassword': 'Enter a password',
    'invite.validation.noConfirmPassword': 'Enter a password confirmation',
    'invite.validation.passwordsMismatch': "Passwords don't match",
    'invite.hint.enterPasswordForAccount': 'Please set a password for your account',
    'invite.buttons.confirm.title': 'Confirm',
    'invite.notification.accountConfirmed': 'You have successfully completed account registration! Use the specified password to log in to your personal account',

    'common.close': 'Close',

    'fg.components.footer.contactEmailDescription': 'For any questions, write to the email',
    'kromos.components.footer.contactEmailDescription': 'For any questions, write to the email',
    'fg.components.footer.contactEmail': 'lab@f-genetics.com',
    'kromos.components.footer.contactEmail': 'lab@kromos.ge',
    'fg.components.footer.yearSince': '2020',
    'kromos.components.footer.yearSince': '2022',
    'fg.components.footer.company': 'f-genetics.com',
    'kromos.components.footer.company': 'kromos.ge',
}